
import { useState } from "react";
import Overview from "./Overview";
import Orders from "./Orders";
import Users from "./Users";
import Providers from "./Providers";
import Products from "./Products";
import Disputes from "./Disputes";
import Revenue from "./Revenue";
import Verifications from "./Verifications";
import Pricing from "./Pricing";

export default function Dashboard({ supabase, session }) {
  const [activeTab, setActiveTab] = useState("overview");
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const navItems = [
    { id: "overview", label: "Overview", icon: "📊" },
    { id: "orders", label: "Orders", icon: "📦" },
    { id: "users", label: "Customers", icon: "👥" },
    { id: "providers", label: "Providers", icon: "🏪" },
    { id: "products", label: "Products", icon: "🛍️" },
    { id: "disputes", label: "Disputes", icon: "⚠️" },
    { id: "revenue", label: "Revenue", icon: "💰" },
    { id: "verifications", label: "Verifications", icon: "✅" },
    { id: "pricing", label: "Pricing & Fuel", icon: "⛽" },
  ];

  async function handleSignOut() { await supabase.auth.signOut(); }

  const renderPage = () => {
    switch (activeTab) {
      case "overview": return <Overview supabase={supabase} />;
      case "orders": return <Orders supabase={supabase} />;
      case "users": return <Users supabase={supabase} />;
      case "providers": return <Providers supabase={supabase} />;
      case "products": return <Products supabase={supabase} />;
      case "disputes": return <Disputes supabase={supabase} />;
      case "revenue": return <Revenue supabase={supabase} />;
      case "verifications": return <Verifications supabase={supabase} />;
      case "pricing": return <Pricing supabase={supabase} />;
      default: return <Overview supabase={supabase} />;
    }
  };

  return (
    <div style={{ display: "flex", height: "100vh", background: "#0a0a0a", fontFamily: "-apple-system, BlinkMacSystemFont, sans-serif", overflow: "hidden" }}>
      <div style={{ width: sidebarOpen ? 240 : 72, background: "#111", borderRight: "1px solid #222", display: "flex", flexDirection: "column", transition: "width 0.2s", flexShrink: 0 }}>
        <div style={{ padding: "20px 16px", borderBottom: "1px solid #222", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          {sidebarOpen && <div style={{ color: "#fff", fontSize: 22, fontWeight: "bold" }}><span style={{ color: "#00A651" }}>K</span>argoSL</div>}
          <button style={{ background: "none", border: "none", color: "#666", cursor: "pointer", fontSize: 12, padding: 4 }} onClick={() => setSidebarOpen(!sidebarOpen)}>{sidebarOpen ? "◀" : "▶"}</button>
        </div>
        <nav style={{ flex: 1, padding: "12px 8px", display: "flex", flexDirection: "column", gap: 4 }}>
          {navItems.map(item => (
            <button key={item.id} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 12px", borderRadius: 8, border: "none", background: activeTab === item.id ? "#00A65120" : "none", color: activeTab === item.id ? "#00A651" : "#666", cursor: "pointer", textAlign: "left", width: "100%" }} onClick={() => setActiveTab(item.id)}>
              <span style={{ fontSize: 18, flexShrink: 0 }}>{item.icon}</span>
              {sidebarOpen && <span style={{ fontSize: 14, fontWeight: "500" }}>{item.label}</span>}
            </button>
          ))}
        </nav>
        <div style={{ padding: "16px 8px", borderTop: "1px solid #222" }}>
          {sidebarOpen && <p style={{ color: "#444", fontSize: 11, padding: "0 12px", marginBottom: 8, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{session.user.email}</p>}
          <button style={{ display: "flex", alignItems: "center", gap: 8, padding: "8px 12px", borderRadius: 8, border: "none", background: "none", color: "#666", cursor: "pointer", width: "100%", fontSize: 13 }} onClick={handleSignOut}>{sidebarOpen ? "🚪 Sign Out" : "🚪"}</button>
        </div>
      </div>
      <div style={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <div style={{ background: "#111", borderBottom: "1px solid #222", padding: "16px 24px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <h1 style={{ color: "#fff", fontSize: 20, fontWeight: "bold", margin: 0 }}>{navItems.find(n => n.id === activeTab)?.icon} {navItems.find(n => n.id === activeTab)?.label}</h1>
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <span style={{ background: "#00A65120", color: "#00A651", padding: "4px 12px", borderRadius: 20, fontSize: 13, fontWeight: "600" }}>🟢 Live</span>
            <span style={{ color: "#666", fontSize: 13 }}>{new Date().toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long", year: "numeric" })}</span>
          </div>
        </div>
        <div style={{ flex: 1, overflow: "auto", padding: 24 }}>{renderPage()}</div>
      </div>
    </div>
  );
}
